import type { PartialFlagValues } from './definitions';

/** Keeps known flag names with boolean values, drops everything else. */
export function pickFlagValues<Name extends string>(
  names: readonly Name[],
  values: Readonly<Record<string, unknown>>
): PartialFlagValues<Name> {
  const result: PartialFlagValues<Name> = {};

  for (const name of names) {
    const value = values[name];
    if (typeof value === 'boolean') {
      result[name] = value;
    }
  }

  return result;
}
